<template>
  <div>
    <div class=" mainLoader" v-if="loading">
    </div>
    <div class="realbody" style="margin-bottom: 0px;">
      <div class="container ramsey" >
        <div class="row">
          <div class="col-md-2 text-center">
            <img class="signman" src="../../../assets/imgs/singin_man.png" />
          </div>
          <div class="col-md-8 signinpanel text-center">
            <p class="s_panel_title mplus2p-r spacing5-9 black mgtop10">{{ $t("Login_title") }}</p>
            <fb-signin-button id="fbButton" :params="fbSignInParams" @success="onSignInSuccess" @error="onSignInError">
              <svg aria-hidden="true" class="svg-icon iconFacebook" width="24" height="24" viewBox="0 0 16 18">
                <path d="M1.88 1C1.4 1 1 1.4 1 1.88v14.24c0 .48.4.88.88.88h7.67v-6.2H7.46V8.4h2.09V6.61c0-2.07 1.26-3.2 3.1-3.2.88 0 1.64.07 1.87.1v2.16h-1.29c-1 0-1.19.48-1.19 1.18V8.4h2.39l-.31 2.42h-2.08V17h4.08c.48 0 .88-.4.88-.88V1.88c0-.48-.4-.88-.88-.88H1.88z" fill="#fff"></path>
              </svg>
              <span>{{$t('facebook_button')}}</span>
            </fb-signin-button>

            <div class="liner">
              <hr class="halfline" style="float: left;" />
              <span class="darkergray" style="font-size: 19px;">{{$t('OR')}}</span>
              <hr class="halfline" style="float: right;" />
            </div>
            <form @submit.prevent="doSigninNormal" name="form">
              <div class="form-group input text-left" :class="{ invalid: $v.email.$error && emailLostFocus }">
                <label class="mplus2p-m spacing1-2 black signlabel">{{$t('l_email')}} <span style="color: red;">*</span>
                </label>
                <input 
                    placeholder="yourname@example.com" 
                    type="email" 
                    class="form-control login_widget"
                    name="email" 
                    v-model="$v.email.$model"
                    id="email" 
                    autofocus />
                <!-- <div class="help-block" v-if="!$v.email.email && emailLostFocus">{{$t('l_email_incorrect')}}</div> -->
                 <div class="help-block" v-if="!$v.email.email">{{$t('r_c_email_validation')}}</div>
                    <div class="help-block" v-if="!$v.email.req && emailLostFocus">{{$t('required_filed')}}</div>
              </div>
              <div class="form-group input text-left" :class="{ invalid: $v.password.$error && passwordLostFocus }" style="margin-top: 20px;">
                <label class="mplus2p-m spacing1-2 black signlabel">{{$t('l_password')}} <span style="color: red;">*</span>
                </label>
                <input 
                      :placeholder="$t('passwordPlaceholder')" 
                      type="password" 
                      class="form-control login_widget" 
                      name="password"
                      v-model="$v.password.$model"
                      id="password" 
                      autofocus/>
                 <div class="help-block" v-if="!$v.password.minLength">{{$t('r_input_password_validation')}}</div>
                  <div class="help-block" v-if="!$v.password.req && passwordLostFocus">{{$t('required_filed')}}</div>
              </div>
              <div class="form-group" style="margin-top: 40px;">
                <button type="submit" class="btn bluebtn singinbtns mplus2p-r spacing1-2" style="font-size: 1.125rem; font-weight: bold;">{{$t('loginButtonTitle')}}
                </button>
              </div>
            </form>
            <div class="text-right" style="margin-top: 20px;">
              <div >
                <p style="margin-bottom: .2rem;"></p>
              </div>
                <a href="javascript:void(0)">
                <span @click="forgotPassword" class="addlinks mplus2p-m spacing1-2 blue">{{$t('forgotTitle')}} &nbsp;
                  <i class="fa fa-angle-right" aria-hidden="true"></i></span></a>
              <p style="margin-bottom: .2rem;"></p>
              <a href="https://e3-pro.com/contact/engineer/" class="d-block">
                <span class="addlinks mplus2p-m spacing1-2 blue">{{$t('nextTitle')}} &nbsp;
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                </span>
              </a>
              <p style="margin-bottom: .2rem;"></p>
              <a href="https://e3-pro.com/contact/engineer/" class="d-block">
                <span class="addlinks mplus2p-m spacing1-2 blue">{{$t('inquiryTitle')}} &nbsp;
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                </span>
              </a>
            </div>
          </div>
          <div class="col-md-2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  maxLength,
  email,
  minLength,
  sameAs
} from "vuelidate/lib/validators";
import axios from "axios";
import { EventBus } from "../../../main";
import Raven from "raven-js";

export default {
  mixins: [validationMixin],

  validations: {
    password: { req:required, minLength: minLength(6) },
    email: { req:required, email }
  },
  data() {
    return {
      loading: false,
      model: {},
      password: "",
      email: "",
      result : '',
      emailLostFocus: false,
      passwordLostFocus: false,
      fbSignInParams: {
        scope: "public_profile,email"
      },
      showVerificationLinkButton: false
    };
  },
  created() {
    this.checkMaintence()
    var vm = this;
    if (localStorage.getItem("user")) {
      if (localStorage.getItem("role") == "engineer") {
        var data = JSON.parse(localStorage.getItem("user"));
        var userId = data.id;
        var userToken = data.user_token;
        this.$router.push("/engineer/profile/" + userToken);
      }
      if (localStorage.getItem("role") == "company_user") {
        var data = JSON.parse(localStorage.getItem("user"));
        var userId = data.user_token;
        var companyId = data.company.company_token;
        this.$router.push(
          "/company/company-user-profile/" + companyId + "/" + userId
        );
      }
    } else {
      this.$router.push("/global/signin");
    }
    EventBus.$on("showErrorEmail", email => {
      this.$toaster.error(vm.$i18n.t("facebook_error_email"));
    });
    EventBus.$on("facebookloading", data => {
      this.loading = data;
    });


  },
  methods: {
     checkMaintence(){
      axios
        .get("/check-maintenance")
        .then(res => {
          if(res.data.maintenance)
          {
            this.$router.push("/global/maintenance");
          }
        })
        .catch(error => console.log(error));
    },
    forgotPassword() {
      this.$router.push("/global/user/forgot-password");
    },
    onSignInSuccess() {
      this.loading = true;
      setTimeout(() => {
        this.$store.dispatch("fbLogin", this.loding);
      }, 1);
    },
    onSignInError(error) {
      // `error` contains any error occurred.
      console.log("OH NOES", error);
    },
    doSigninNormal() {
      const thisVue = this;
      this.loading = true;

      const formData = {
        email: this.email,
        password: this.password
      };
      this.$v.$touch()
      if(this.$v.$invalid ){
        this.loading = false;
        this.emailLostFocus = true;
        this.passwordLostFocus = true;
         $('html, body').animate({scrollTop:110}, 'slow')
      }
      else{
   return axios
        .post("/login", formData, {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          this.result = res;
          if (!res.data.result) {
            if (res.data.errors) {
              for (var i = 0; i < res.data.errors.length; i++) {
              this.$toaster.error(res.data.errors[i].message);
              if (
                res.data.errors[0].message == "Your email is not yet verified"
              ) {
                this.showVerificationLinkButton = true;
              }
              if (res.data.errors[i].field === "email") {
                this.$toaster.error(res.data.errors[i].message);
              }
              if (res.data.errors[i].field === "password") {
                this.$toaster.error(res.data.errors[i].message);
              }
            }
            }
            
            this.loading = false;
            this.$v.$reset();
            return res
          } else {
            this.loading = false;
            Raven.setUserContext({
              email: res.data.user.email,
              id: res.data.user.id
            });
            return(this.$store.dispatch("login", res));
            this.$v.$reset();
            this.email = "";
            this.password = "";
          }
        })
        .catch((err) => { 
          return err
        });

      }
    }
  }
};
</script>

<style scoped>
.fb-signin-button {
  /* This is where you control how the button looks. Be creative! */
  cursor: pointer;
  display: inline-block;
  padding: 16px;
  border-radius: 3px;
  width: 100%;
  height: 60px;
  background-color: #4267b2;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  transition: background-color 0.218s, border-color 0.218s, box-shadow 0.218s;
  outline: none;
  overflow: hidden;
  position: relative;
  vertical-align: middle;
  white-space: nowrap;
  margin: auto;
  box-shadow: 0 2px 4px 0 rgba(49, 79, 147, 0.24),
    0 -2px 4px 0 rgba(49, 79, 147, 0.12);
  border-radius: 6.4px;
}

.iconFacebook {
  float: left;
}

.input input {
  font: inherit;
  width: 100%;
  padding: 6px 12px;
  box-sizing: border-box;
  border: 1px solid #ccc;
}

.input.inline input {
  width: auto;
}

.input input:focus {
  outline: none;
  border: 1px solid #3d7dd8;
  background-color: #eee;
}

.input.invalid label {
  color: red;
}

.input.invalid input {
  border: 1px solid red;
  background-color: #ffc9aa;
}

.input select {
  border: 1px solid #ccc;
  font: inherit;
}

.slabel_panel {
  position: absolute;
  left: 56px;
}

.signin_label {
  font-size: 1.75rem;
  font-weight: bold;
}

.signin_label_jp {
  font-size: 1rem;
}

.ramsey {
  margin-top: 100px;
}

.signinpanel {
  padding: 0px 80px;
  padding-bottom: 60px;
}

.fa-facebook {
  float: left;
  font-size: 25px;
  margin-top: 2px;
  margin-left: 50px;
  font-weight: bold;
}

.fbsigntext {
  font-size: 1.125rem;
  margin-left: -50px;
  font-weight: bold;
}

.singinbtns {
  height: 60px;
  padding: 16px;
  width: 100%;
  margin: auto;
  cursor: pointer;
  box-shadow: 0 2px 4px 0 rgba(49, 79, 147, 0.24),
    0 -2px 4px 0 rgba(49, 79, 147, 0.12);
}

.liner {
  height: 50px;
  padding-top: 15px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.halfline {
  width: 40%;
  border: solid 1px #788ca0;
}

.login_widget {
  height: 50px;
  background-color: #f0f2f4;
  border-radius: 3.2px;
  border: solid 1px #eef0f0;
}

.signlabel {
  font-size: 1rem;
  font-weight: 500;
}

.addlinks {
  font-size: 0.875rem;
  font-weight: 500;
}

.fa-angle-right {
  font-size: 1.2rem !important;
}

.fa-angle-left {
  font-size: 1.2rem !important;
}

.signman {
  width: 100%;
  margin-top: 430px;
}

@media screen and (max-width: 768px) {
  .fbsigntext {
    margin-left: 0px;
  }

  .fa-facebook {
    margin-left: 0px;
  }

  .signman {
    width: 100px;
    margin-top: 0px;
  }

  .slabel_panel {
    position: unset;
    left: 0;
    margin-top: 110px;
    margin-left: 56px;
  }

  .ramsey {
    margin-top: 0px;
  }
}

@media screen and (max-width: 415px) {
  .signinpanel {
    padding: 0px 10px;
    padding-bottom: 60px;
  }
}
</style>
